export default "__VITE_ASSET__1b330f0c__"